import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadio = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 8.5,
		fill: "#fff",
		stroke: "currentColor"
	})
});
export default SvgRadio;
